import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "style", "backdropStyle", "className", "children", "footer", "visible", "onOpen", "onClose", "onCancel", "zIndex", "placement", "maskCloseable", "title", "appModalId", "closeOnPressEscape", "wrapperClassName", "wrapperStyle", "footerStyle", "icons", "header", "closable", "bodyStyle", "modalStyle", "initialFocusIndex", "ariaLabel", "ariaLabelledby", "closeAriaLabel", "attachDOM", "container", "blockScroll", "closeTabindex", "role", "isDynamic", "triggerEvent", "initialFocus", "onBodyScroll", "maskBodyPadding"];
// @ts-nocheck
import React, { useEffect, useState } from "react";
import ClassNames from "classnames";
import { KEY_VALUES, mergeRefs, Portal, getScrollWidth, getActiveElement } from '../utils';
import * as focusTrap from 'focus-trap';
import { useLocalization } from "@appkit4/react-api";

// window['trap'] = null;

;
var activeElement = null;
var closeElement;
export var StaticModal = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    style = props.style,
    backdropStyle = props.backdropStyle,
    className = props.className,
    children = props.children,
    footer = props.footer,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? false : _props$visible,
    onOpen = props.onOpen,
    onClose = props.onClose,
    onCancel = props.onCancel,
    zIndex = props.zIndex,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'center' : _props$placement,
    _props$maskCloseable = props.maskCloseable,
    maskCloseable = _props$maskCloseable === void 0 ? true : _props$maskCloseable,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$appModalId = props.appModalId,
    appModalId = _props$appModalId === void 0 ? '' : _props$appModalId,
    _props$closeOnPressEs = props.closeOnPressEscape,
    closeOnPressEscape = _props$closeOnPressEs === void 0 ? true : _props$closeOnPressEs,
    wrapperClassName = props.wrapperClassName,
    wrapperStyle = props.wrapperStyle,
    footerStyle = props.footerStyle,
    icons = props.icons,
    header = props.header,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? true : _props$closable,
    bodyStyle = props.bodyStyle,
    modalStyle = props.modalStyle,
    _props$initialFocusIn = props.initialFocusIndex,
    initialFocusIndex = _props$initialFocusIn === void 0 ? 0 : _props$initialFocusIn,
    _props$ariaLabel = props.ariaLabel,
    ariaLabel = _props$ariaLabel === void 0 ? '' : _props$ariaLabel,
    _props$ariaLabelledby = props.ariaLabelledby,
    ariaLabelledby = _props$ariaLabelledby === void 0 ? '' : _props$ariaLabelledby,
    closeAriaLabel = props.closeAriaLabel,
    attachDOM = props.attachDOM,
    container = props.container,
    _props$blockScroll = props.blockScroll,
    blockScroll = _props$blockScroll === void 0 ? true : _props$blockScroll,
    _props$closeTabindex = props.closeTabindex,
    closeTabindex = _props$closeTabindex === void 0 ? 0 : _props$closeTabindex,
    _props$role = props.role,
    role = _props$role === void 0 ? 'dialog' : _props$role,
    isDynamic = props.isDynamic,
    triggerEvent = props.triggerEvent,
    _props$initialFocus = props.initialFocus,
    initialFocus = _props$initialFocus === void 0 ? true : _props$initialFocus,
    onBodyScroll = props.onBodyScroll,
    _props$maskBodyPaddin = props.maskBodyPadding,
    maskBodyPadding = _props$maskBodyPaddin === void 0 ? true : _props$maskBodyPaddin,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  // const [trap, setTrap] = useState(null);
  var _useState = useState(''),
    currentAriaLabel = _useState[0],
    setCurrentAriaLabel = _useState[1];
  var _useState2 = useState(''),
    currentAriaLabelledby = _useState2[0],
    setCurrentAriaLabelledby = _useState2[1];
  var modalRef = React.useRef(null);
  var modalRootRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var _React$useState = React.useState(false),
    keyboardFocus = _React$useState[0],
    setKeyboardFocus = _React$useState[1];
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  var didMountRef = React.useRef(false);
  var clickRef = React.useRef(false);
  var keyboardRef = React.useRef(false);
  var isElement = function isElement(target) {
    var targetElement = document.querySelector(target);
    if (typeof HTMLElement === 'object') {
      return targetElement instanceof HTMLElement;
    } else {
      return targetElement && typeof targetElement === 'object' && targetElement !== null && targetElement.nodeType === 1 && typeof targetElement.nodeName === 'string';
    }
  };
  var randomText = React.useMemo(function () {
    return Math.random().toString(36).substring(2);
  }, []);
  var setLabelAndLabelLedby = function setLabelAndLabelLedby() {
    setCurrentAriaLabelledby(title && title.trim().length > 0 && !ariaLabelledby.trim() ? appModalId + 'modalTitle' : ariaLabelledby.trim() ? ariaLabelledby : '');
    setCurrentAriaLabel(title && title.trim().length > 0 && !ariaLabel.trim() ? title : ariaLabel.trim() ? ariaLabel : '');
  };
  var getFirstFocusableElement = function getFirstFocusableElement(findElement) {
    var controls = "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])";
    var focusable = findElement === null || findElement === void 0 ? void 0 : findElement.querySelectorAll(controls); //(containerRef.current! as HTMLElement)?
    if (focusable && focusable.length > 0) {
      return Array.from(focusable)[0];
    } else {
      return;
    }
  };
  useEffect(function () {
    return setLabelAndLabelLedby();
  }, [props.title, props.ariaLabel, props.ariaLabelledby]);
  var onKeyDownEvent = function onKeyDownEvent(event) {
    if (closeOnPressEscape && event.key === KEY_VALUES.ESC) {
      handleClose && handleClose(event);
    } else if (!closeOnPressEscape && event.keyCode === 27) {
      if (activeElement && activeElement.classList.value.indexOf('ap-button') > -1) {
        activeElement.classList.remove('keyboard-focus');
      }
    }
  };
  useEffect(function () {
    var eventHandler = function eventHandler(event) {
      var keycode = event.which;
      if (keycode === 9) {
        if (activeElement && activeElement.classList.value.indexOf('ap-button') > -1) {
          if (!activeElement.classList.contains('keyboard-focus')) activeElement.classList.add('keyboard-focus');
        }
        var firstFocusable = getFirstFocusableElement(containerRef.current);
        if (firstFocusable && firstFocusable.getAttribute('type') === 'button' && firstFocusable.className.indexOf('ap-button') < 0) {
          firstFocusable.style.removeProperty('outline');
          // firstFocusable.classList?.remove('focus');
        }
      }

      keyboardRef.current = true;
    };
    window.addEventListener('keydown', eventHandler);
    return function () {
      window.removeEventListener('keydown', eventHandler);
    };
  });
  useEffect(function () {
    if (visible) {
      var _modalRootRef$current, _modalRootRef$current2;
      modalRootRef.current.style.visibility = 'visible';
      modalRootRef === null || modalRootRef === void 0 ? void 0 : (_modalRootRef$current = modalRootRef.current) === null || _modalRootRef$current === void 0 ? void 0 : (_modalRootRef$current2 = _modalRootRef$current.children[0]) === null || _modalRootRef$current2 === void 0 ? void 0 : _modalRootRef$current2.classList.add('show');
      document.body.classList.add('ap-body-overflow-hidden');
    } else {
      modalRootRef.current.style.display = 'none';
    }
    setLabelAndLabelLedby();
    if (attachDOM) {
      var element = containerRef.current;
      if (attachDOM === 'body') {
        document.body.appendChild(element);
      } else {
        if (isElement(attachDOM)) {
          document.querySelector(attachDOM).appendChild(element);
        } else {
          throw new Error("\n                  cannot append " + element + " to " + attachDOM + ";\n              ");
        }
      }
    }
    return function () {
      setTimeout(function () {
        document.body.classList.remove('ap-body-overflow-hidden');
        document.body.style.removeProperty('padding-right');
        if (modalRootRef && modalRootRef.current && !visible) {
          var _modalRootRef$current3, _modalRootRef$current4;
          modalRootRef.current.style.visibility = 'hidden';
          modalRootRef === null || modalRootRef === void 0 ? void 0 : (_modalRootRef$current3 = modalRootRef.current) === null || _modalRootRef$current3 === void 0 ? void 0 : (_modalRootRef$current4 = _modalRootRef$current3.children[0]) === null || _modalRootRef$current4 === void 0 ? void 0 : _modalRootRef$current4.classList.remove('show');
          modalRootRef.current.style.display = 'none';
        }
      });
    };
  }, []);
  useEffect(function () {
    var _window$event;
    var trigger = triggerEvent ? triggerEvent.type : (_window$event = window.event) === null || _window$event === void 0 ? void 0 : _window$event.type;
    if (isDynamic && !didMountRef.current || !isDynamic && didMountRef.current) {
      var _ref, _window$event2;
      clickRef.current = ((_ref = triggerEvent ? triggerEvent.toString() : (_window$event2 = window.event) === null || _window$event2 === void 0 ? void 0 : _window$event2.toString()) === null || _ref === void 0 ? void 0 : _ref.indexOf('PointerEvent')) > -1;
    }
    if (didMountRef.current) {
      if (visible) {
        var modalElement = containerRef.current;
        if (ariaLabelledby && modalElement) {
          if (containerRef.current.querySelector("#dialogCurrentLabel-" + randomText)) {
            var _containerDom$querySe;
            var containerDom = container ? container instanceof HTMLElement ? container : container.node : document;
            containerRef.current.querySelector("#dialogCurrentLabel-" + randomText).textContent = ((_containerDom$querySe = containerDom.querySelector("#" + ariaLabelledby)) === null || _containerDom$querySe === void 0 ? void 0 : _containerDom$querySe.textContent) || '';
          }

          // modalElement.setAttribute('aria-labelledby', ariaLabelledby);
        } else if (!ariaLabelledby && modalElement) {
          modalElement === null || modalElement === void 0 ? void 0 : modalElement.removeAttribute('aria-labelledby');
        }
        typeof onOpen === 'function' && onOpen();
        var scrollWidth = getScrollWidth();
        if (!document.body.classList.contains('ap-body-overflow-hidden')) {
          document.body.classList.add('ap-body-overflow-hidden');
          if (maskBodyPadding) {
            document.body.style.paddingRight = scrollWidth + 'px';
            document.body.style.paddingRight = '1rem';
          }
        }
        if (modalRef.current) {
          var _focusable$;
          modalRootRef.current.style.display = 'block';
          activeElement = getActiveElement();
          var focusable = modalRef.current.querySelectorAll('button, [href], input, select, textarea, li, a,[tabindex]:not([tabindex="-1"])');
          var focusIndex = initialFocusIndex >= 0 ? initialFocusIndex : focusable.length + initialFocusIndex;
          var firstFocusable = focusable[focusIndex] || focusable[0];
          var trap = focusTrap.createFocusTrap(modalRef.current, {
            initialFocus: initialFocus && (trigger === 'click' && ((_focusable$ = focusable[0]) === null || _focusable$ === void 0 ? void 0 : _focusable$.type) === 'radio' ? false : firstFocusable),
            // initialFocus: focusable[0],
            clickOutsideDeactivates: true,
            escapeDeactivates: function escapeDeactivates() {
              var _modalRef$current, _modalRef$current2;
              if ((_modalRef$current = modalRef.current) !== null && _modalRef$current !== void 0 && _modalRef$current.querySelector('.ap-dropdown-select.visible') || (_modalRef$current2 = modalRef.current) !== null && _modalRef$current2 !== void 0 && _modalRef$current2.querySelector('.ap-combobox-input-box.visible')) {
                return false;
              }
              return closeOnPressEscape;
            }
          });
          // @ts-ignore
          window["trap"] = trap;
          if (trigger === 'keydown' || trigger === 'keyup' || trigger === 'keypress' || trigger === 'message' && !clickRef.current) {
            var _modalRootRef$current5, _focusElement;
            // Add 'keyboard-focus' to all appkit buttons when open with keyboard
            (_modalRootRef$current5 = modalRootRef.current.querySelectorAll('.ap-button,.ap-field-wrapper,.ap-search-input,.ap-avatar')) === null || _modalRootRef$current5 === void 0 ? void 0 : _modalRootRef$current5.forEach(function (element) {
              if (!element.classList.contains('keyboard-focus')) element.classList.add('keyboard-focus');
            });
            var focusElement = getFirstFocusableElement(firstFocusable);
            if (focusElement === undefined && firstFocusable) {
              focusElement = firstFocusable;
              setTimeout(function () {
                if (!focusElement.classList.contains('keyboard-focus')) focusElement.parentNode.classList.add('keyboard-focus');
                if (!focusElement.classList.contains('focus')) focusElement.parentNode.classList.add('focus');
              }, 0);
            }
            if (initialFocus) (_focusElement = focusElement) === null || _focusElement === void 0 ? void 0 : _focusElement.focus();
          } else {
            var _modalRootRef$current6;
            (_modalRootRef$current6 = modalRootRef.current.querySelectorAll('.ap-button,.ap-field-wrapper,.ap-search-input,.ap-avatar')) === null || _modalRootRef$current6 === void 0 ? void 0 : _modalRootRef$current6.forEach(function (element) {
              element.classList.remove('keyboard-focus');
            });
            if (firstFocusable && firstFocusable.type === "button" && firstFocusable.className.indexOf('ap-button') < 0) firstFocusable.style.outline = 'none';
          }
          setTimeout(function () {
            if (blockScroll) {
              var _modalRootRef$current7, _modalRootRef$current8;
              if (modalRootRef && modalRootRef.current) modalRootRef.current.style.visibility = 'visible';
              modalRootRef === null || modalRootRef === void 0 ? void 0 : (_modalRootRef$current7 = modalRootRef.current) === null || _modalRootRef$current7 === void 0 ? void 0 : (_modalRootRef$current8 = _modalRootRef$current7.children[0]) === null || _modalRootRef$current8 === void 0 ? void 0 : _modalRootRef$current8.classList.add('show');
            }
          }, 50);
          setTimeout(function () {
            try {
              if (window["trap"]) window["trap"].activate();
            } catch (e) {}
          }, 100);
        }
      } else {
        if (keyboardRef.current) clickRef.current = false;else clickRef.current = true;
        typeof onClose === 'function' && onClose();
        setTimeout(function () {
          if (blockScroll) {
            var _modalRootRef$current9, _modalRootRef$current10;
            if (modalRootRef && modalRootRef.current) modalRootRef.current.style.visibility = 'hidden';
            modalRootRef === null || modalRootRef === void 0 ? void 0 : (_modalRootRef$current9 = modalRootRef.current) === null || _modalRootRef$current9 === void 0 ? void 0 : (_modalRootRef$current10 = _modalRootRef$current9.children[0]) === null || _modalRootRef$current10 === void 0 ? void 0 : _modalRootRef$current10.classList.remove('show');
          }
        }, 50);
        setTimeout(function () {
          // if (modalRootRef?.current?.children[0]?.classList.contains('ap-modal-wrapper') && modalRootRef?.current?.children[0]?.classList.contains('show')) {
          //   document.body.style.overflow = 'auto';
          //   document.body.style.paddingRight = '0';
          // }
          document.body.classList.remove('ap-body-overflow-hidden');
          document.body.style.removeProperty('padding-right');
          if (modalRootRef && modalRootRef.current) modalRootRef.current.style.display = 'none';
          if (trigger === 'keydown' || trigger === 'keyup' || trigger === 'keypress' || trigger === 'message' && (!clickRef.current || keyboardRef.current)) {
            // Add 'keyboard-focus' to appkit trigger button when close with keyboard
            if (activeElement && activeElement.classList.value.indexOf('ap-button') > -1) {
              if (!activeElement.classList.contains('keyboard-focus')) {
                activeElement.classList.add('keyboard-focus');
              }
            }
          }
          if (activeElement && document.activeElement && ['body', 'button'].indexOf(getActiveElement().tagName.toLowerCase()) > -1) {
            if (activeElement && activeElement.classList.value.indexOf('ap-button') > -1) {
              clickRef.current && !keyboardRef.current ? activeElement.classList.remove('keyboard-focus') : activeElement.classList.add('keyboard-focus');
            }
            activeElement.focus();
          }
        }, 350);
        if (window["trap"]) window["trap"].deactivate();
      }
    } else {
      didMountRef.current = true;
    }
    keyboardRef.current = false;
  }, [visible]);
  var wrapperClasses = ClassNames("ap-modal-wrapper", wrapperClassName, {
    // "show": visible,
  });
  var modalClasses = ClassNames("ap-modal", className);
  var handleClose = function handleClose(e) {
    if (window["trap"]) window["trap"].deactivate();
    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
  };
  var handleMouseDown = function handleMouseDown(event) {
    // setKeyboardFocus(false);
  };
  var wrapperClickHandle = function wrapperClickHandle(event) {
    if (event !== null && event !== void 0 && event.target.closest('.ap-modal') || !(event !== null && event !== void 0 && event.target.closest('.ap-modal-wrapper'))) return;
    if (maskCloseable) {
      onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }
  };
  var mousedownEvent = function mousedownEvent(event) {
    clickRef.current = true;
    keyboardRef.current = false;
  };
  function debounce(callback, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback();
      }, delay);
    };
  }
  var handleScroll = debounce(function () {
    onBodyScroll === null || onBodyScroll === void 0 ? void 0 : onBodyScroll();
  }, 100);
  var alignItemsStyle = placement === 'top' ? 'flex-start' : placement === 'bottom' ? 'flex-end' : 'center';
  var justifyContentStyle = placement === 'top' ? 'center' : placement === 'bottom' ? 'center' : placement;
  var innerWrapperStyle = _extends({
    alignItems: alignItemsStyle,
    justifyContent: justifyContentStyle
  }, wrapperStyle);
  var closeclasses = ClassNames(' ap-modal-header-icon ap-modal-header-close');

  //style={{ visibility: visible ? 'visible' : 'hidden' }}
  return /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-root",
    ref: modalRootRef
  }, /*#__PURE__*/React.createElement("div", {
    id: id || appModalId,
    className: wrapperClasses,
    style: innerWrapperStyle,
    ref: mergeRefs(containerRef, ref),
    role: role,
    "aria-modal": "true",
    "aria-label": currentAriaLabel,
    "aria-labelledby": "dialogCurrentLabel-" + randomText,
    onClick: wrapperClickHandle,
    onKeyDown: onKeyDownEvent,
    onMouseDown: mousedownEvent
  }, /*#__PURE__*/React.createElement("span", {
    id: "dialogCurrentLabel-" + randomText,
    style: {
      opacity: 0,
      width: 0,
      height: 0
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: modalRef,
    className: modalClasses,
    style: modalStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-header"
  }, header, /*#__PURE__*/React.createElement("h2", {
    className: "ap-modal-title"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-body",
    style: bodyStyle,
    onScroll: handleScroll
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-footer",
    style: footerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-footer-customize"
  }, footer)), /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-header-icons-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-header-icons"
  }, icons), closable && /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-header-close-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: closeclasses,
    "aria-label": closeAriaLabel || t("close"),
    onClick: handleClose,
    onMouseDown: handleMouseDown,
    tabIndex: closeTabindex
  }, /*#__PURE__*/React.createElement("span", {
    className: "Appkit4-icon icon-close-outline"
  })))))));
});
export var Modal = /*#__PURE__*/React.forwardRef(function (props, ref) {
  // const { Portal } = usePortal({ container: props.container });
  return /*#__PURE__*/React.createElement(Portal, {
    element: /*#__PURE__*/React.createElement(StaticModal, _extends({
      ref: ref
    }, props)),
    container: props.container
  });
});